import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  Input,
} from '@angular/core';
import { ActiveModal } from '@app/modules/core-modal/models/active.modal';
import { ModalCommandActions } from '@app/modules/modal/modal.enums';
import { ModalComponent } from '@app/modules/modal-components-common/modal.component';
import { I18n } from '@app/i18n/strings-keys';

@Component({
  selector: 'xea-item-count-validation-modal',
  templateUrl: './item-count-validation-modal.component.html',
  styleUrls: ['./item-count-validation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ItemCountValidationModalComponent extends ModalComponent {
  @Input() public itemName = '';
  @Input() public itemId = '';
  public closeButtonText = I18n.CommonButtons.Close;

  public constructor(
    public activeModal: ActiveModal,
    injector: Injector,
  ) {
    super(injector);
  }

  public closeModal(): void {
    this.activeModal.execute({ action: ModalCommandActions.CLOSE });
  }

  public closeOnBackdropClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    if (!target.closest('.modal-body')) {
      this.closeModal();
    }
  }
}
